import { Trans } from "@lingui/react/macro";
import {
  BackgroundColor,
  SectionContainer,
  SectionTitle,
  SectionTitleBody,
  SectionTitleHeading
} from "@silversea-ssc/ui-components-react";
import { ConfiguredInstantSearch } from "components/Algolia/ConfiguredInstantSearch";
import CruisesSliderHits, {
  CruisesSliderHitsProps
} from "components/Algolia/CruisesSliderHits";
import { FYCQuery } from "components/FindYourCruise/FYCQueryBuilder";
import React from "react";
import { Configure } from "react-instantsearch";
import { isAlgoliaAnalyticsEnabled } from "components/Algolia/algoliaAnalytics";

export type LastMinuteCruisesSliderProps = Pick<
  CruisesSliderHitsProps,
  "promosContent" | "shipsContent" | "showPriceForFare"
> & {
  searchQuery: FYCQuery;
  searchIndexName: string;
  showDestination?: boolean;
  dataContentName: string;
  analyticsName: string;
  backgroundColor: BackgroundColor;
};

const CruisesSlider: React.FC<
  React.PropsWithChildren<LastMinuteCruisesSliderProps>
> = ({
  searchQuery,
  searchIndexName,
  backgroundColor,
  promosContent,
  showDestination = true,
  shipsContent,
  showPriceForFare,
  dataContentName,
  analyticsName,
  children
}) => {
  return (
    <div>
      <SectionContainer
        backgroundColor={backgroundColor}
        spacingTop="regular"
        spacingBottom="regular"
        dataContentName={dataContentName}
      >
        {children}
        <ConfiguredInstantSearch
          indexName={searchIndexName}
          analyticsName={analyticsName}
        >
          <Configure
            filters={searchQuery}
            analytics={isAlgoliaAnalyticsEnabled()}
            //enablePersonalization={true}
            distinct
            offset={0}
            length={20}
          />

          <CruisesSliderHits
            variantColor={backgroundColor == "white" ? "neutral01" : "white"}
            showDestination={showDestination}
            promosContent={promosContent}
            shipsContent={shipsContent}
            showPriceForFare={showPriceForFare}
          />
        </ConfiguredInstantSearch>
      </SectionContainer>
    </div>
  );
};

export default CruisesSlider;
